import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { resetUser } from '../../actions/clinician';
import { connect } from 'react-redux';
import { hasKeys } from '../../components/simpleFunctions';
import { bindActionCreators } from 'redux';
import sponsors from '../../assets/img/final-page-header.png';
import { loginSuccessRedirectUrl, msalConfig, loginRequest } from '../../config-client';
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
} from 'reactstrap';
import './Login.module.css';

export const Msal = require('msal');
export const myMSALObj = new Msal.UserAgentApplication(msalConfig);

// import { makeStyles } from '@material-ui/core/styles';
// import Button from '@material-ui/core/Button';



// const useStyles = makeStyles(theme => ({
//   button: {
//     margin: theme.spacing(1),
//   },
//   input: {
//     display: 'none',
//   },
// }));


const styles = {
  margin: '115px',
  button: {
    margin: 'auto',
    height: '80%',
    width: '90%',
    fontSize: '3.2rem',

  },
  card: {
    width: '60%',
    height: '90%',
    margin: 'auto',
  },
  image: {
    width: '600px',
  },
  title: {
    color: 'white',
  },
  terms: {
    width: '85%',
    margin: 'auto',
  },
  agree: {
    width: '30%',
    margin: '10px auto',
  },
  termsBody: {
    padding: '0px 30px',
  },
};

const LoginProps = {
  history: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
  ]).isRequired,
};


/* eslint-disable jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control */
/* eslint-enable jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control */

const Popup = ({ errorMessage }) => (
  <div className="error-container">
    <Card className="card">
      <CardBody className="cardbody">
        <CardTitle className="title">
          Login Failed
        </CardTitle>
        <CardSubtitle className="subtitle">
          {errorMessage}
        </CardSubtitle>
      </CardBody>
    </Card>
  </div>
);

class Login extends React.Component {
  constructor(props) {
    super(props);

    // initial states of username and password are undefined/blank
    this.state = {
      username: '',
      password: '',
      refreshed: false,
      clicked: false,
      agreed: false,
    };

    this.redirect = this.redirect.bind(this);
    this.agreed = this.agreed.bind(this);
  }

  // redirect to login API
  redirect() {
    myMSALObj.loginPopup(loginRequest)
      .then((loginResponse) => {
        this.props.history.replace(loginSuccessRedirectUrl);
      // token should now be in local storage
      }).catch((error) => {
        console.log(error);
      });
    return 'Waiting for Redirect';
  }

  agreed() {
    this.setState({
      clicked: true,
      agreed: true,
    });
  }


  componentDidMount() {
    this.props.resetUser();
    if (window.performance) {
      if (performance.navigation.type === 1) {
        this.setState({
          refreshed: true,
        });
      }
    }
  }

  render() {
    if ((this.props.clinician.clinician === null) ||
      ((typeof this.props.clinician.clincian !== 'undefined') &&
        (this.props.clinician.clinician.Error !== null))) {
      return (
        <div className="login">
          <img src={sponsors} alt="Sponsors" style={styles.image} />
          <h3 style={styles.title}>Paediatric Cancer Survivorship Triage Tool</h3>
          <Card style={styles.terms}>
            <h1>Terms & Conditions</h1>
            <p style={styles.termsBody}>Lorem ipsum dolor sit amet, sit dicit munere te. Augue tantas splendide nam cu. Quo tale corpora iracundia no, quo at wisi incorrupte concludaturque, ne vis populo nostrum accusata. Graecis gloriatur deterruisset an eos, duis brute urbanitas et sea, sed iuvaret epicurei intellegebat ad. Usu diam quas necessitatibus ea, decore aliquip docendi qui at, id posse vituperatoribus nam. Id semper voluptua dissentias vis.
            Ius suas meis dolorum ne. Tota dicant indoctum ad pri, et mazim ceteros eos. Vis ne fabellas menandri atomorum. Cu aliquando dissentiet mei.
            No malis regione sed. Eum dicat melius id, albucius iudicabit in his, ex quo duis sale. Ea ubique nusquam explicari eum, quo possim insolens no, ad eam menandri accusamus. In vidit conclusionemque per, sea ei augue consectetuer, ne putant albucius intellegebat has.
            </p>
            <Button
              disabled={this.state.clicked}
              style={styles.agree}
              onClick={this.agreed}
            >
              I Agree To These Terms & Conditions
            </Button>
          </Card>
          <div className="container">

            <Card className="card" style={styles.card}>
              <Button
                disabled={!this.state.agreed}
                style={styles.button}
                color="primary"
                onClick={this.redirect}
              >
                {' '}
              Login{' '}
              </Button>
            </Card>

          </div>
          {(hasKeys(this.props, 'location.state.error') &&
            this.props.location.state.error !== '' &&
            !this.state.refreshed) ?
            <Popup errorMessage={this.props.location.state.error} />
            : null}
        </div>
      );
    }
    return (
      <div className="login">
        <img src={sponsors} alt="Sponsors" style={styles.image} />
        <h3 style={styles.title}>Paediatric Cancer Survivorship Triage Tool</h3>
        <Card style={styles.terms}>
          <h1>Terms & Conditions</h1>
          <p style={styles.termsBody}>Lorem ipsum dolor sit amet, sit dicit munere te. Augue tantas splendide nam cu. Quo tale corpora iracundia no, quo at wisi incorrupte concludaturque, ne vis populo nostrum accusata. Graecis gloriatur deterruisset an eos, duis brute urbanitas et sea, sed iuvaret epicurei intellegebat ad. Usu diam quas necessitatibus ea, decore aliquip docendi qui at, id posse vituperatoribus nam. Id semper voluptua dissentias vis.
          Ius suas meis dolorum ne. Tota dicant indoctum ad pri, et mazim ceteros eos. Vis ne fabellas menandri atomorum. Cu aliquando dissentiet mei.
          No malis regione sed. Eum dicat melius id, albucius iudicabit in his, ex quo duis sale. Ea ubique nusquam explicari eum, quo possim insolens no, ad eam menandri accusamus. In vidit conclusionemque per, sea ei augue consectetuer, ne putant albucius intellegebat has.
          </p>
          <Button
            disabled={this.state.clicked}
            style={styles.agree}
            onClick={this.agreed}
          >
            I Agree To These Terms & Conditions
          </Button>
        </Card>
        <div className="container">

          <Card className="card" style={styles.card}>
            <Button
              disabled={!this.state.agreed}
              style={styles.button}
              color="primary"
              onClick={this.redirect}
            >
              {' '}
              Login{' '}
            </Button>
          </Card>

        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  clinician: state.clinician,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      resetUser,
    },
    dispatch,
  );

const decoratedLogin = connect(mapStateToProps, mapDispatchToProps)(Login);
// Proptypes
Login.propTypes = LoginProps;

export default reduxForm({
  form: 'Login', // unique identifier for the form
})(decoratedLogin);



// WEBPACK FOOTER //
// ./src/containers/Login/Login.js